'use client';

import { motion } from 'framer-motion';
import { ArrowRight, Play } from 'lucide-react';
import Link from 'next/link';

import IconButton from '@/components/common/IconButton';

import AppStore from './AppStore';
import GooglePlay from './GooglePlay';

export const HeroContent = () => {
  return (
    <motion.div
      className="flex flex-1 flex-col items-center gap-5 p-8 lg:items-start lg:gap-10"
      // initial={{ opacity: 0 }}
      // animate={{ opacity: 1 }}
      // transition={{
      //   duration: 0.3,
      //   ease: 'ease',
      // }}
    >
      <div className="overflow-visible">
        <div className="text-center font-bold text-primary-500 lg:text-left">
          Zump FnB
        </div>
        <h1 className="[&_span]:block">
          <>Ứng dụng quản lý</>
          <span className="text-center leading-relaxed text-orange-500">
            Nhà hàng, quán ăn
          </span>
          <>tối ưu nhất</>
        </h1>
      </div>
      <p className="font-medium">
        Tiên phong áp dụng đột phá mới trong lĩnh vực quản lý bán hàng FnB
      </p>
      <div className="flex w-fit flex-col items-center gap-5 lg:gap-10">
        <div className="flex gap-4 max-sm:flex-wrap max-sm:justify-center md:gap-5 lg:gap-8">
          <IconButton
            label="Tư vấn ngay"
            variant="primary"
            disableTranslate
            icon={<ArrowRight />}
            className="button-shinny"
            onClick={() => window.$chatwoot.toggle('open')}
          />
          <Link href="/#download">
            <IconButton
              label="Khám phá Zump"
              variant="secondary"
              disableTranslate
              icon={<Play className="fill-white" />}
              className="button-shinny"
            />
          </Link>
        </div>
        <div className="flex w-full items-center before:m-2 before:flex-1 before:border-b before:border-primary-200 before:content-['_'] after:m-2 after:flex-1 after:border-b after:border-primary-200 after:content-['_']">
          <p>Hoặc trải nghiệm ứng dụng miễn phí</p>
        </div>
        <div className="flex gap-2 max-sm:flex-wrap max-sm:justify-center md:gap-4 lg:gap-5">
          <AppStore />
          <GooglePlay />
        </div>
      </div>
    </motion.div>
  );
};
